import { CheckboxStyled } from 'v6/Pages/Homepage/styled';
import styled from 'styled-components';

export function TosField({ error, value, onChange }: any) {
  return (
    <CheckboxStyled id="tos" name="tos" checked={value} onChange={onChange}>
      {' '}
      <TosText error={error}>
        I agree to the{' '}
        <a href="https://skedsocial.com/terms-of-service/" target="_blank" rel="noreferrer">
          Terms of Service
        </a>{' '}
        and{' '}
        <a href="https://skedsocial.com/privacy-policy/" target="_blank" rel="noreferrer">
          Privacy Policy
        </a>
        .
      </TosText>
    </CheckboxStyled>
  );
}

const TosText = styled.div<{ error: any }>`
  color: ${props => (props.error ? 'var(--errorRed)' : 'var(--Text-T02, #454545)')};

  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;
